import { render, staticRenderFns } from "./SectionDonneesFormulaire.vue?vue&type=template&id=b453ebe8&scoped=true&"
import script from "./SectionDonneesFormulaire.vue?vue&type=script&lang=js&"
export * from "./SectionDonneesFormulaire.vue?vue&type=script&lang=js&"
import style0 from "./SectionDonneesFormulaire.vue?vue&type=style&index=0&id=b453ebe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b453ebe8",
  null
  
)

export default component.exports